module.exports = __webpack_public_path__ + "static/6-90e56fef84fc156ac0f0ae041f9d6e32.jpg";